module.exports = __webpack_public_path__ + "static/joc_10-5a268111707ed33c6ec78b56f4a77a93.jpg";